export enum LANGUAGE {
  ENGLISH = 'en',
  VIETNAMESE = 'vi',
}

export enum GENDER {
  MALE = 1,
  FEMALE = 0,
}

export const GenderLabel: Record<GENDER, string> = Object.freeze({
  [GENDER.MALE]: 'Nam',
  [GENDER.FEMALE]: 'Nữ',
});

export const GenderOptions = [
  {
    value: GENDER.MALE,
    label: GenderLabel[GENDER.MALE],
  },
  {
    value: GENDER.FEMALE,
    label: GenderLabel[GENDER.FEMALE],
  },
];

export const MAX_NOTE_LENGTH = 1000;

export enum REGION {
  DOMESTIC = 'domestic',
  INTERNATIONAL = 'international',
}

export enum MODULE_TYPE {
  HOTEL = 'hotel',
  TOUR = 'tour',
  AMUSEMENT_TICKETS = 'amusement_tickets',
}

export const ModuleTypeLabels = {
  [MODULE_TYPE.HOTEL]: 'Khách sạn',
  [MODULE_TYPE.TOUR]: 'Tour',
  [MODULE_TYPE.AMUSEMENT_TICKETS]: 'Vé vui chơi',
};
